var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 58,
    viewBox: "0 0 65 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8391_81309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4466 37.861C29.4466 38.6643 29.7683 39.4347 30.3409 40.0027C30.9135 40.5708 31.6902 40.8899 32.5 40.8899C33.3098 40.8899 34.0865 40.5708 34.6591 40.0027C35.2317 39.4347 35.5534 38.6643 35.5534 37.861C35.5534 37.0577 35.2317 36.2873 34.6591 35.7193C34.0865 35.1512 33.3098 34.8321 32.5 34.8321C31.6902 34.8321 30.9135 35.1512 30.3409 35.7193C29.7683 36.2873 29.4466 37.0577 29.4466 37.861ZM30.4644 18.6781V30.2888C30.4644 30.5664 30.6934 30.7936 30.9733 30.7936H34.0267C34.3066 30.7936 34.5356 30.5664 34.5356 30.2888V18.6781C34.5356 18.4004 34.3066 18.1733 34.0267 18.1733H30.9733C30.6934 18.1733 30.4644 18.4004 30.4644 18.6781ZM60.7249 46.4428L34.2621 1.00963C33.8677 0.334439 33.187 0 32.5 0C31.813 0 31.126 0.334439 30.7379 1.00963L4.27515 46.4428C3.49271 47.7932 4.47234 49.4717 6.03721 49.4717H58.9628C60.5277 49.4717 61.5073 47.7932 60.7249 46.4428ZM10.8845 44.6823L32.5 7.56589L54.1155 44.6823H10.8845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.602 1.51293L31.6021 1.51294L31.6049 1.50791C31.7976 1.17277 32.1354 1 32.5 1C32.8596 1 33.197 1.16921 33.3984 1.51368C33.3985 1.51379 33.3985 1.5139 33.3986 1.51401L59.8596 46.9442C59.8598 46.9445 59.86 46.9448 59.8602 46.9451C60.2492 47.6182 59.769 48.4717 58.9628 48.4717H6.03721C5.23104 48.4717 4.75087 47.6182 5.13977 46.9452C5.13997 46.9449 5.14018 46.9445 5.14039 46.9442L31.602 1.51293ZM10.0203 44.179L9.14489 45.6823H10.8845H54.1155H55.8551L54.9797 44.179L33.3641 7.06264L32.5 5.57881L31.6359 7.06264L10.0203 44.179ZM31.0452 39.2928C30.661 38.9117 30.4466 38.3965 30.4466 37.861C30.4466 37.3255 30.661 36.8103 31.0452 36.4292C31.4297 36.0478 31.9528 35.8321 32.5 35.8321C33.0472 35.8321 33.5703 36.0478 33.9548 36.4292C34.339 36.8103 34.5534 37.3255 34.5534 37.861C34.5534 38.3965 34.339 38.9117 33.9548 39.2928C33.5703 39.6742 33.0472 39.8899 32.5 39.8899C31.9528 39.8899 31.4297 39.6742 31.0452 39.2928ZM33.5356 29.7936H31.4644V19.1733H33.5356V29.7936Z",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8391_81309",
    x: 0,
    y: 0,
    width: 65,
    height: 57.4717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8391_81309"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8391_81309",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/Attention.d32cef720c4db84721506aa65d4b790d.svg";
export { ForwardRef as ReactComponent };